import { lazy } from "react";

const UserPma = lazy(() => {
  return import("containers/userPma");
});

const Fund = lazy(() => {
  return import("containers/fund");
});

const FundDetail = lazy(() => {
  return import("containers/fundDetail");
});

const BuyOrder = lazy(() => {
  return import("containers/buyOrder");
});

const SellOrder = lazy(() => {
  return import("containers/sellOrder");
});

const Payment = lazy(() => {
  return import("containers/payment");
});

const FundTransactions = lazy(() => {
  return import("containers/fundTransactions");
});

const FundOrders = lazy(() => {
  return import("containers/fundOrders");
});

const UserInfo = lazy(() => {
  return import("containers/userInfo");
});

const Onboarding = lazy(() => {
  return import("containers/onboarding");
});

const Pma = lazy(() => {
  return import("containers/pma");
});

const PmaDetail = lazy(() => {
  return import("containers/pmaDetail");
});

const UserBanks = lazy(() => {
  return import("containers/userBanks");
});

const PaymentReceipt = lazy(() => {
  return import("containers/paymentReceipt");
});

const Faq = lazy(() => {
  return import("containers/faq");
});

const FaqDetail = lazy(() => {
  return import("containers/faqDetail");
});

const FundOrderDetail = lazy(() => {
  return import("containers/fundOrdersDetail");
});

const ChangeBroker = lazy(() => {
  return import("components/changeBroker/page");
});

const BankTransactions = lazy(() => {
  return import("containers/bankTransactions");
});

const BankCardToCard = lazy(() => {
  return import("containers/bankCardToCard");
});

const BankSheba = lazy(() => {
  return import("containers/bankSheba");
});

const CardOnboarding = lazy(() => {
  return import("containers/cardOnboarding");
});

const Referral = lazy(() => {
  return import("containers/referral");
});

const Prize = lazy(() => {
  return import("containers/prize");
});

const PmaTransactions = lazy(() => {
  return import("containers/pmaTransactions");
});

const PmaInventoryIncrease = lazy(() => {
  return import("containers/pmaInventoryIncrease");
});

const PmaStocks = lazy(() => {
  return import("containers/pmaStocks");
});

const FastInvest = lazy(() => {
  return import("containers/cardOnboarding/components/limitAmount/fastInvest");
});

const BankAssetBack = lazy(() => {
  return import("containers/bankAssetBack");
});

const BankSetting = lazy(() => {
  return import("containers/bankSetting");
});

const BankOrders = lazy(() => {
  return import("containers/bankOrders");
});

const DepositCertificate = lazy(() => {
  return import("containers/depositCertificate");
});

const AccountHistory = lazy(() => {
  return import("containers/accountHistory");
});

const Regulation = lazy(() => {
  return import("containers/regulations");
});

const PdfFiles = lazy(() => {
  return import("containers/regulations/components/pdfFiles");
});

const FundProfit = lazy(() => {
  return import("containers/fundProfit");
});
const CalendarRange = lazy(() => {
  return import("containers/accountHistory/components/drawerContent");
});

const BankIncrease = lazy(() => {
  return import("containers/bankIncrease/index");
});

const Cardex = lazy(() => {
  return import("containers/cardex/index");
});

const Voucher = lazy(() => {
  return import("containers/voucher");
});

const routes = [
  {
    path: "/pma",
    element: <Pma />,
  },
  {
    path: "/pma/*",
    element: <PmaDetail />,
  },

  {
    path: "/user-pma/*",
    element: <UserPma />,
  },
  {
    path: "/funds",
    element: <Fund />,
  },
  {
    path: "/funds/*",
    element: <FundDetail />,
  },
  {
    path: "/buy",
    element: <BuyOrder />,
  },
  {
    path: "/sell",
    element: <SellOrder />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/payment/receipt",
    element: <PaymentReceipt />,
  },
  {
    path: "/fund-transactions/*",
    element: <FundTransactions />,
  },
  {
    path: "/fund-orders/*",
    element: <FundOrders />,
  },
  {
    path: "/user-info",
    element: <UserInfo />,
  },
  {
    path: "/onboarding",
    element: <Onboarding />,
  },
  {
    path: "/accounts",
    element: <UserBanks />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/faq/*",
    element: <FaqDetail />,
  },
  {
    path: "/fund-order/*",
    element: <FundOrderDetail />,
  },
  {
    path: "/change-broker",
    element: <ChangeBroker />,
  },

  {
    path: "/bank/onboarding",
    element: <CardOnboarding />,
  },
  {
    path: "/bank/transactions",
    element: <BankTransactions />,
  },
  {
    path: "/bank/operations/card-to-card",
    element: <BankCardToCard />,
  },
  {
    path: "/bank/operations/sheba",
    element: <BankSheba />,
  },
  {
    path: "/bank/asset-back",
    element: <BankAssetBack />,
  },
  {
    path: "/referral",
    element: <Referral />,
  },
  {
    path: "/prize",
    element: <Prize />,
  },
  {
    path: "/pma-transactions",
    element: <PmaTransactions />,
  },
  {
    path: "/pma-stocks",
    element: <PmaStocks />,
  },
  {
    path: "/fast-invest",
    element: <FastInvest />,
  },
  {
    path: "/bank/setting",
    element: <BankSetting />,
  },
  {
    path: "/bank/orders",
    element: <BankOrders />,
  },
  {
    path: "/fund/deposit-certificate",
    element: <DepositCertificate />,
  },
  {
    path: "/fund/account-history",
    element: <AccountHistory />,
  },
  {
    path: "/regulation",
    element: <Regulation />,
  },

  {
    path: "/regulation-pdf",
    element: <PdfFiles />,
  },
  {
    path: "/fund/profit-sharing",
    element: <FundProfit />,
  },
  {
    path: "/date-range",
    element: <CalendarRange />,
  },
  {
    path: "/bank/increase-amount",
    element: <BankIncrease />,
  },
  {
    path: "/cardex",
    element: <Cardex />,
  },
  {
    path: "/cardex",
    element: <Cardex />,
  },
  {
    path: "/pma/inventory-increase",
    element: <PmaInventoryIncrease />,
  },
  {
    path: "/voucher",
    element: <Voucher />,
  },
];

export default routes;
